/*
  this method is called when some value is entered in the search option and the search button is pressed
  value[0] - is the search type (Name | Email)
  value[1] - is the search value string
  popupSearch is set to true to show the popup screen
  searchMoreAvailable is set to true so the 'More' option on the popup screen is enabled
  */
import AxiosConfig from "../../../axiosConfig";
import * as CONSTANT from "constants/text";

export const searchResultHandler = function (value) {
  this.setState({
    searchType: value[0],
    searchValue: value[1],
    searchPage: 1,
    searchMoreAvailable: true,
    searchLessAvailable: true,
  });
  if (
    this.state.searchOrigin === CONSTANT.GROUPS ||
    this.state.searchOrigin === CONSTANT.GROUPS_PAGE
  ) {
    this.fetchGroupsData(this, value[0], value[1], 1, true);
  } else {
    this.fetchFriendsData(this, value[0], value[1], 1, true);
  }
};

/*
  This method os called when from the popup friends screen the cancel button is pressed
  popupSearch is set to false to close the popup screen
   */
export const searchResultCancelClick = function () {
  this.setState({ popupSearch: false });
  this.setState({ searchPage: 1 });
  this.setState({ searchMoreAvailable: true });
  /*TODO: This may not be the best way to reload the Friends page*/
  /*TODO: But it is like this to re make the AXIOS calls and render the new friend request*/
  if (this.state.searchOrigin === CONSTANT.FRIENDS) {
    window.location.assign("/friends");
  } else if (this.state.searchOrigin === CONSTANT.GROUPS) {
    this.state.history.push(
      "/groups/" +
        CONSTANT.VIEW +
        "/" +
        this.state.groupDetails.id +
        "/" +
        this.state.groupDetails.name
    );
  } else if (this.state.searchOrigin === CONSTANT.GROUPS_PAGE) {
    window.location.assign("/groups");
  }
};

/*
  This method os called when from the popup friends screen the cancel button is pressed
  popupSearch is set to false to close the popup screen
  Same as Cancel but Done is better UX
   */
export const searchResultDoneClick = function () {
  this.setState({ popupSearch: false });
  this.setState({ searchPage: 1 });
  this.setState({ searchMoreAvailable: true });
  /*TODO: This may not be the best way to reload the Friends page*/
  /*TODO: But it is like this to re make the AXIOS calls and render the new friend requests that were just invited*/
  if (this.state.searchOrigin === CONSTANT.FRIENDS) {
    window.location.assign("/friends");
  } else if (this.state.searchOrigin === CONSTANT.GROUPS) {
    this.state.history.push(
      "/groups/" +
        CONSTANT.VIEW +
        "/" +
        this.state.groupDetails.id +
        "/" +
        this.state.groupDetails.name
    );
  } else if (this.state.searchOrigin === CONSTANT.GROUPS_PAGE) {
    window.location.assign("/groups");
  }
};

/*
  This method is called when from the popup friends screen the next button is pressed
  searchPage - is increased by 1 to fetch the next batch of result from the API
   */
export const searchResultNextClick = function () {
  this.setState({ searchPage: this.state.searchPage + 1 });
  this.fetchFriendsData(
    this,
    this.state.searchType,
    this.state.searchValue,
    this.state.searchPage + 1,
    true
  );
};

/*
  This method is called when from the popup friends screen the back button is pressed
  searchPage - is increased by 1 to fetch the next batch of result from the API
   */
export const searchResultBackClick = function () {
  this.setState({ searchPage: this.state.searchPage - 1 });
  this.fetchFriendsData(
    this,
    this.state.searchType,
    this.state.searchValue,
    this.state.searchPage - 1,
    true
  );
};

/*
  When an image is clicked
   1. First check if the email id is existing in the map or not
   2. If the email id is not existing in the map then add the user details in the 'selectedFriends' list
   3. Close the popup div
   */
export const searchResultImageClick = function (value) {
  const newFriend = {};
  newFriend["user_photo"] = value[0];
  newFriend["user_email"] = value[1];
  newFriend["user_name"] = value[2];

  if (!this.state.selectedFriends.has(newFriend["user_email"])) {
    this.state.selectedFriends.set(newFriend["user_email"], newFriend);
  }
  //this.setState({ popupSearch: false });
};

/*
  The method is used to send the selected user a new friend request.
  When the invite button is pressed it changes the
  */
export const searchResultViewClick = function (value) {
  // if the type of invite is a new member invite for a group, use a different URL
  if (value[1] === CONSTANT.NEW_MEMBERS) {
    window.location.pathname = `/profile/${CONSTANT.GROUP_INVITE_URL}/${value[3]}/${value[2]}/new-member/${value[0]}/`;
  }
  // else if the type of invite is to a new group
  else if (value[1] === CONSTANT.GROUPS) {
    window.location.pathname = `/groups/${CONSTANT.JOIN_URL}/${value[3]}/${value[2]}/`;
  } else {
    //Go to the User detail page in a new tab.
    //referenced https://stackoverflow.com/questions/51434254/react-router-open-link-on-new-tab-and-redirect-to-home-page/51434782
    window.location.pathname = `/profile/${CONSTANT.JOIN_URL}/${value[0]}/`;
  }
};

/*
  The method is used to remove an already selected friend whom we were going to send an invite.
  The value is the email
   */
export const removeInviteClick = function (value) {
  this.state.selectedFriends.delete(value);
  // This is just a useless state change just to notify changes in the state
  this.setState({ searchPage: 1 });
};

// Update the state when the invite message changes
export const inviteMessageChange = function (e) {
  this.setState({ inviteMessage: e.target.value });
};

//Method to dynamically add more input text fields on button click
export const unregisteredUserAddMore = function () {
  let errorFlag = false;
  for (let i = 0; i < this.state.unregisteredUser.length; i++) {
    if (this.state.unregisteredUser[i]["email_address"].trim().length === 0) {
      errorFlag = true;
      break;
    }
  }

  if (errorFlag) {
    this.setState({ unregisteredUserIssue: "Empty Spaces Available" });
  } else {
    let unregisteredUser = this.state.unregisteredUser;
    unregisteredUser.push({
      email_address: "",
      issue: "",
    });
    this.setState({
      unregisteredUser,
      unregisteredUserIssue: "",
    });
  }
};

//When the email id on the unregistered user is updated
export const unregisteredUserEmailChange = function (e, index) {
  let emailIssue = "";
  const emailaddress = e.target.value;
  if (emailaddress.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) === null) {
    emailIssue = "Invalid Email";
  } else {
    emailIssue = "";
  }
  if (emailaddress.length === 0) emailIssue = "";
  this.state.unregisteredUser[index] = {
    email_address: e.target.value,
    issue: emailIssue,
  };
  this.setState({ unregisteredUser: this.state.unregisteredUser });
  this.setState({ unregisteredUserIssue: "" });
};
//When the email id on the unregistered user is updated (Build your team page - friends)
export const unregisteredUserEmailChangeFriends = function (e, index) {
  let emailIssue = "";
  const emailaddress = e.target.value;
  if (
    emailaddress.length === 0 ||
    emailaddress.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) === null
  ) {
    emailIssue = "Invalid Email";
  } else {
    emailIssue = "";
  }
  this.state.unregisteredUser[index] = {
    email_address: e.target.value,
    issue: emailIssue,
  };
  this.setState({ unregisteredUser: this.state.unregisteredUser });
  this.setState({ unregisteredUserIssue: "" });
};
//When an invite to an unregistered user is deleted
export const unregisteredUserDeleteClick = function (e, index) {
  this.setState({ unregisteredUserIssue: "" });
  this.state.unregisteredUser.splice(index, 1);
  this.setState({ unregisteredUser: this.state.unregisteredUser });
};

export const unregisteredUserEmailValidate = function (index) {
  const emailaddress = this.state.unregisteredUser[index]["email_address"];
  if (
    emailaddress.length > 0 &&
    emailaddress.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) === null
  ) {
    this.state.unregisteredUser[index] = {
      email_address: emailaddress,
      issue: "Invalid Email",
    };
  }
};

/*
  This method will actually call the backend API and fetch the friends result based on the search query
   */
export const fetchFriendsDataHelper = function (
  obj,
  searchType,
  searchValue,
  page,
  searchMoreFlag
) {
  if (searchType === "email") {
    AxiosConfig.get(`impactprojects/search_friend_email/`, {
      params: {
        email: searchValue,
        page: page,
      },
    }).then(function (response) {
      if ("results" in response.data) {
        obj.setState({ popupSearch: true });
        obj.setState({ friendsSearchData: response.data["results"] });
      }
      if ("next" in response.data) {
        if (response.data["next"] === null) {
          obj.setState({ searchMoreAvailable: false });
        } else {
          obj.setState({ searchMoreAvailable: true });
        }
      }
      if ("previous" in response.data) {
        if (response.data["previous"] === null) {
          obj.setState({ searchLessAvailable: false });
        } else {
          obj.setState({ searchLessAvailable: true });
        }
      }
    });
  } else if (searchType === CONSTANT.USERNAME) {
    AxiosConfig.get(`friends/friend_search/`, {
      params: {
        text: searchValue,
        page: page,
      },
    }).then(function (response) {
      if ("results" in response.data) {
        obj.setState({ popupSearch: true });
        obj.setState({ friendsSearchData: response.data["results"] });
      }
      if ("next" in response.data) {
        if (response.data["next"] === null) {
          obj.setState({ searchMoreAvailable: false });
        } else {
          obj.setState({ searchMoreAvailable: true });
        }
      }
      if ("previous" in response.data) {
        if (response.data["previous"] === null) {
          obj.setState({ searchLessAvailable: false });
        } else {
          obj.setState({ searchLessAvailable: true });
        }
      }
    });
  } else {
    AxiosConfig.get(`impactprojects/search_friend_name/`, {
      params: {
        text: searchValue,
        page: page,
      },
    }).then(function (response) {
      if ("results" in response.data) {
        obj.setState({ popupSearch: true });
        obj.setState({ friendsSearchData: response.data["results"] });
      }
      if ("next" in response.data) {
        if (response.data["next"] === null) {
          obj.setState({ searchMoreAvailable: false });
        } else {
          obj.setState({ searchMoreAvailable: true });
        }
      }
      if ("previous" in response.data) {
        if (response.data["previous"] === null) {
          obj.setState({ searchLessAvailable: false });
        } else {
          obj.setState({ searchLessAvailable: true });
        }
      }
    });
  }
};

/*
 * This method will actually call the backend API and fetch the friends result based on the search query
 */
export const fetchGroupsDataHelper = function (
  obj,
  searchType,
  searchValue,
  page,
  searchMoreFlag,
  groupId
) {
  if (searchType === CONSTANT.NEW_MEMBERS) {
    AxiosConfig.get(`groups/${groupId}/search-new-members/`, {
      params: {
        text: searchValue,
        page: page,
      },
    }).then(function (response) {
      if ("results" in response.data) {
        obj.setState({ popupSearch: true });
        obj.setState({ groupsSearchData: response.data["results"] });
      }
      if ("next" in response.data) {
        if (response.data["next"] === null) {
          obj.setState({ searchMoreAvailable: false });
        } else {
          obj.setState({ searchMoreAvailable: true });
        }
      }
      if ("previous" in response.data) {
        if (response.data["previous"] === null) {
          obj.setState({ searchLessAvailable: false });
        } else {
          obj.setState({ searchLessAvailable: true });
        }
      }
    });
  } else if (searchType === CONSTANT.GROUPS) {
    AxiosConfig.get(`groups/search-new-groups/`, {
      params: {
        text: searchValue,
        page: page,
      },
    }).then(function (response) {
      if ("results" in response.data) {
        obj.setState({ popupSearch: true });
        obj.setState({ groupsSearchData: response.data["results"] });
      }
      if ("next" in response.data) {
        if (response.data["next"] === null) {
          obj.setState({ searchMoreAvailable: false });
        } else {
          obj.setState({ searchMoreAvailable: true });
        }
      }
      if ("previous" in response.data) {
        if (response.data["previous"] === null) {
          obj.setState({ searchLessAvailable: false });
        } else {
          obj.setState({ searchLessAvailable: true });
        }
      }
    });
  }
};
